module.exports = __webpack_public_path__ + "static/media/theregaltraders.501ee27e.jpg";